import React, { useState } from "react";
import { StyleSheet } from "react-native";
import {
  Box,
  MainText,
  MainTitle,
  PressableOpacity,
} from "app/components/common";
import i18n from "@microdoing/shared/i18n";
import CumulativeWeekChart from "./CumulativeWeekChart";
import Theme from "@microdoing/shared/constants/Theme";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";

const defaultData = [
  { x: "s0", y: 0 },
  { x: "s1", y: 0 },
];

interface IProps {
  data: any;
}

const EvolutionChart = ({ data = defaultData }: IProps) => {
  return (
    <Box paddingHorizontal="xm">
      <Box
        width="100%"
        display="flex"
        alignItems="flex-start"
        justifyContent="center"
        flexDirection="row"
      >
        <Box flex={1} width="100%">
          <MainTitle variant="l6-bold">
            {i18n.t("progress-chart-evolution-title")}
          </MainTitle>
          <MainText marginTop="xxs" variant="l3-medium" color="neutral.600">
            {i18n.t("average-of-my-weekly-realized-actions")}
          </MainText>
        </Box>
      </Box>
      <CumulativeWeekChart data={data} />
    </Box>
  );
};

export default EvolutionChart;
